module.exports = __webpack_public_path__ + "static/img/6359_phase_function_Paper_PointsHejduk_Prediction.99d74e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6359_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gnWF
// module chunks = 0